import React from 'react';
import PropTypes from 'prop-types';
import Badge from "./Badge";

export default class DocumentState extends React.Component {

  render() {
    if (!this.props.state){
      return null;
    }
    return (
      <p><Badge color={'#' + this.props.state.color}/><small>{this.props.state.name}</small></p>
    );
  }

}

DocumentState.propTypes = {
  state: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/DocumentState.js